var React = require('react');

function GraphUp32px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M31 22H1a1 1 0 0 1-1-1V1a1 1 0 1 1 2 0v19h29a1 1 0 1 1 0 2zM27 9a1 1 0 0 1-1-1V6.328l-7.342 6.425c-.058.051-.127.079-.192.114-.036.02-.068.048-.105.063-.117.045-.238.07-.361.07a1 1 0 0 1-.39-.082c-.043-.019-.077-.054-.117-.078-.069-.041-.141-.074-.2-.133l-3.346-3.345-6.297 5.397a.995.995 0 0 1-1.409-.108 1 1 0 0 1 .108-1.41l7-6c.042-.035.092-.049.137-.076.059-.037.114-.077.179-.1.058-.021.117-.025.178-.035.066-.01.13-.025.197-.022.062.002.121.021.182.035.063.015.126.024.186.051.061.027.111.071.166.111.044.031.094.049.133.088l3.338 3.339L24.482 5H23a1 1 0 1 1 0-2h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1z","key":1})]);
}

GraphUp32px.displayName = "GraphUp32px";

GraphUp32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32 22"};

module.exports = GraphUp32px;

GraphUp32px.default = GraphUp32px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/32px/graph-up-32px.svg
// module id = 1100
// module chunks = 0